import PaymentsDueModal from './PaymentsDueModal';

export default PaymentsDueModal;
